import React from 'react';
import '../styles/_products.scss';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from '../../../../../services/stringUtil';
import { HeaderTCDI } from '../../components/HeaderTCDI/HeaderTCDI';
import { useNumberFormatter } from '../../../../../hooks/useNumberFormatter';
import { mapGeneralInfoInDataSource, mapProductDataSource } from '../../utils/Helpers/MapperHelper';
import { NoContentView } from '../../components/NoContentView/NoContentView';

export const ProductsSection = ({ data }) => {
  const { t } = useTranslation();
  const { formatNumber } = useNumberFormatter();

  return (
    <section className='products-report'>
      <HeaderTCDI data={mapGeneralInfoInDataSource(data)} />
      <article className="products-info-report">
        <h3 className='content-layout-title'>{capitalizeFirstLetter(t('products'))} ({data.productsCount})</h3>
        <section className='products-info-layout'>
          <div className='products-content'>
            {
              data.products.length ? (
                <table className="products-content-table">
                  <thead>
                    <tr>
                      <th rowSpan={2}></th>
                      <th rowSpan={2}></th>
                      <th colSpan={2}><strong>{t('phisical_advance').toUpperCase()}</strong></th>
                      <th colSpan={2}><strong>{t('financial_advance_title').toUpperCase()}</strong></th>
                    </tr>
                    <tr>
                      <th><strong>{data.products[0].lastYear}</strong></th>
                      <th><strong>{t('end_of_project')}</strong></th>
                      <th><strong>{data.products[0].lastYear}</strong></th>
                      <th><strong>{t('end_of_project')}</strong></th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.products.map((fila, id) => {
                      const mappedProduct = mapProductDataSource(fila)
                      return (
                        <React.Fragment key={id}>
                          {mappedProduct.items.map((item, index) => (
                            <tr key={`${id}-${index}`}>
                              {index === 0 && (
                                <td className='table-items-description content' rowSpan={mappedProduct.items.length}>{mappedProduct.description}</td>
                              )}
                              <td className={'table-items-description' + (index === 0 ? ' row-division' : '')}><strong>{item.component}</strong></td>
                              <td className={(index === 0 ? 'row-division' : '')}>{item.phisical.current}</td>
                              <td className={(index === 0 ? 'row-division' : '')}>{item.phisical.projectEnd}</td>
                              <td className={'table-items-financial' + (index === 0 ? ' row-division' : '')}>{t('dolar_sign')} {formatNumber(item.financial.current)}</td>
                              <td className={'table-items-financial' + (index === 0 ? ' row-division' : '')}>{t('dolar_sign')} {formatNumber(item.financial.projectEnd)}</td>
                            </tr>
                          ))}
                        </React.Fragment>
                      )
                    })}
                  </tbody>
                </table>
              )
                : <NoContentView title={t('last_no_information')} description={capitalizeFirstLetter(t('no_products_related_to_this_project_have_been_found'))} />
            }
          </div>
        </section>
      </article>
    </section>
  )
}
